import {
  createTelemetryManager,
  TELEMETRY_APPLICATION,
} from '@terra/ui-telemetry';

export const { initTelemetry, setTelemetryUser, teardownTelemetry } =
  createTelemetryManager(TELEMETRY_APPLICATION.PORTAL);
